var map = {
	"./airplane.svg": "24be",
	"./balance.svg": "75c6",
	"./car.svg": "14cf",
	"./centralheating.svg": "f122",
	"./cityfinale.svg": "f199",
	"./diesel.svg": "e053",
	"./earth.svg": "6615",
	"./electro.svg": "4276",
	"./elstove.svg": "eb38",
	"./food-icon.svg": "2cd2",
	"./food.svg": "3f35",
	"./gasheating.svg": "69eb",
	"./gastove.svg": "e6b9",
	"./home.svg": "ac9d",
	"./house.svg": "750c",
	"./l-o-veg.svg": "363e",
	"./logo.svg": "5b1c",
	"./minivan.svg": "4393",
	"./passengercar.svg": "9d51",
	"./petrol.svg": "8aad",
	"./stationwagon.svg": "4af5",
	"./statya.svg": "3f2e",
	"./statyatablet.svg": "93f7",
	"./suv.svg": "8b48",
	"./train.svg": "d280",
	"./transport.svg": "f64c",
	"./travel.svg": "34dc",
	"./travelbk.svg": "9d73",
	"./vegan.svg": "b2fb",
	"./zapravka.svg": "b243"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";